import { styled } from 'parkdepot-shared/theme'

export const ButtonContainer = styled('div', () => ({
    marginTop: '3.2rem',
    maxWidth: '24.5rem',
    height: '5rem',
    marginLeft: 'auto',
    marginRight: 'auto'
}))

export const ContentContainer = styled('div', ({ $theme }) => ({
    textAlign: 'center',

    [$theme.mediaQuery.large]: {
        backgroundColor: $theme.colors.white,
        maxWidth: '53rem',
        margin: 'auto'
    }
}))

export const TextWrapper = styled('div', () => ({
    margin: '1.6rem 0'
}))

export const DateWrapper = styled('div', () => ({
    marginBottom: '1.6rem'
}))

export const ErrorIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: '3.2rem',

    [$theme.mediaQuery.large]: {
        fontSize: '4.8rem'
    }
}))

export const FullyBookedContainer = styled('div', () => ({
    marginTop: '1.2rem',
    marginBottom: '0.8rem'
}))

export const CalendarContainer = styled('div', () => ({
    marginLeft: '-1.6rem'
}))
